"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AdminArea = function AdminArea(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22.9",
    width: "24",
    height: "22.9"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.1,19.8c0-0.1-0.1-0.3-0.1-0.4v-5.9c0-0.2,0.1-0.4,0.1-0.6c-0.1,0-0.2-0.1-0.3-0.1l-1-0.3 c-0.3-0.1-0.6-0.2-0.9-0.3v-1.9c0.5-0.3,1.4-1.2,1.5-2.9c0.4-0.2,0.6-0.7,0.6-1.4c0-0.6-0.2-1-0.5-1.3C13.9,4,14.3,2.9,14,1.8 C13.7,0.5,11.8,0,10.2,0c-1.3,0-3,0.4-3.6,1.4C6,1.3,5.6,1.6,5.4,1.9c-0.5,0.7-0.3,1.8,0,2.7C5.3,4.7,5.2,4.9,5.1,5 C5,5.3,4.9,5.6,4.9,5.9c0,0.6,0.2,1.1,0.6,1.4c0.1,1.8,1,2.6,1.5,2.9v1.9c-0.6,0.2-1.3,0.4-1.9,0.6c-2.3,0.8-4.2,1.4-4.6,2.5 C0,16.8,0,19.3,0,19.4c0,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.4,0.1l13.6,0C14.1,19.9,14.1,19.8,14.1,19.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.7,13c-0.2-0.1-0.4-0.1-0.5,0c-0.7,0.5-1.2,0.7-1.7,0.7c-0.6,0-1.2-0.3-1.6-0.8c-0.2-0.2-0.6-0.2-0.8,0 c-0.4,0.5-1,0.8-1.6,0.8c-0.5,0-1.1-0.2-1.7-0.7c-0.2-0.1-0.4-0.1-0.5,0c-0.2,0.1-0.3,0.3-0.3,0.4v5.9c0,0,0,0.1,0,0.1 c0,0.1,0.7,2.4,4.3,3.4c0,0,0.1,0,0.1,0s0.1,0,0.1,0c3.7-1,4.3-3.3,4.3-3.4c0,0,0-0.1,0-0.1v-5.9C24,13.3,23.9,13.1,23.7,13z M21.5,17.9H20v1.5c0,0.3-0.2,0.5-0.5,0.5S19,19.7,19,19.4v-1.5h-1.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H19v-1.5 c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.5h1.5c0.3,0,0.5,0.2,0.5,0.5S21.8,17.9,21.5,17.9z"
  }));
};

var _default = AdminArea;
exports["default"] = _default;